import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import {
    postRefresh,
    type PostLoginResponse,
} from '@starjack/features/authentication';

export const USER_AUTH_CACHE = 'user_auth';

const authUrls = {
    login: urlBuilder('auth', 'login'),
};

export const authenticationApi = baseApiAuthenticated.injectEndpoints({
    endpoints: (builder) => ({
        postLogin: builder.mutation<
            PostLoginResponse,
            { username: string; password: string }
        >({
            query: ({ username, password }) => ({
                method: 'POST',
                url: authUrls.login,
                body: {
                    username,
                    password,
                },
            }),
        }),
    }),
});

export const { usePostLoginMutation } = authenticationApi;

// Re-export shared postRefresh for consistency
export { postRefresh };
